<template>
  <el-switch v-model="version"
             style="float:right;margin-left:5px;"
             active-text="V.2"
             active-color="#13ce66"
             active-value="2"
             inactive-text="V.1"
             inactive-value="1"></el-switch>
</template>

<script>
import storejs from 'store'
import api from '@/api'
import c from '@/config'

export default {
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      version: this.value,
    }
  },
  mounted() {
    // ANALYSE:
    api.log({
      type: 'label:version',
      priority: 'info',
      addr: window.location.href,
      user: storejs.get('user').UserName,
      message: c.version,
    })
  },
  watch: {
    version(val) {
      // set version and reload page
      storejs.set('label:version', val)
      window.location.reload()
    },
  },
}
</script>
